import React from 'react';
export function ProofBar() {
  return <div className="py-7 bg-negro-suave border-y border-[rgba(201,151,43,.15)]" data-id="element-353">
      <div className="container" data-id="element-354">
        <div className="flex justify-center gap-12 flex-wrap max-md:gap-6" data-id="element-355">
          <div className="text-center" data-id="element-356">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-357">
              +4.000
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-358">
              Estudiantes activos
            </span>
          </div>
          <div className="text-center" data-id="element-359">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-360">
              4.8★
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-361">
              Valoración promedio
            </span>
          </div>
          <div className="text-center" data-id="element-362">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-363">
              12
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-364">
              Capítulos profundos
            </span>
          </div>
          <div className="text-center" data-id="element-365">
            <span className="font-playfair text-[2.2rem] font-black text-dorado-claro block leading-none max-sm:text-[1.7rem]" data-id="element-366">
              7
            </span>
            <span className="text-[11px] tracking-[.1em] uppercase text-gris-texto mt-1 block" data-id="element-367">
              Días de garantía
            </span>
          </div>
        </div>
      </div>
    </div>;
}